<template>
  <div class="compantInfo">
    <el-button type="primary" @click="goSomePage('/firmSituation')">增加企业</el-button>

    <div class="search-item">
      <el-form class="form-item" ref="form" :model="form" label-width="70px">
        <el-form-item class="items" label="企业名称：">
          <el-input v-model="form.name" style="width:100%"></el-input>
        </el-form-item>

        <el-form-item class="items" label="行业分类：">
          <el-select v-model="form.classify" placeholder="请选择行业分类" style="width:100%">
            <el-option v-for="(item,index) in classifyList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="items" label="所属地区：">
          <!-- <el-select v-model="form.area" placeholder="请选择所属地区">
             <el-option
                v-for="item in countryCity"
                :key="item.id"
                :label="item.name"
                :value="item.name">
              </el-option>
          </el-select> -->
            <el-cascader
              style="width:100%"
              class="frame"
              size="large"
              :options="options"
              v-model="selectedOptions"
              placeholder="请选择所属地区"
              @change="handleChange"
            />
        </el-form-item>

        <el-form-item class="items" label="在线状态：">
          <el-select v-model="form.status" placeholder="请选择在线状态" style="width:100%">
            <el-option v-for="(item,index) in status"
              :key="index"
              :label="item.status"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>

        <!-- <div>
          <el-button type="primary" @click="getFirmList">查询</el-button>
          <el-button type="info" @click="reset">重置</el-button>
        </div> -->
      </el-form>
      <!-- <el-button type="primary" @click="getFirmList">查询</el-button>
      <el-button type="info" @click="reset">重置</el-button> -->
      <div class="btn-style">
        <el-button type="primary" @click="getFirmList">查询</el-button>
        <el-button type="info" @click="reset">重置</el-button>
      </div>
    </div>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed type="index" label="序号" width="50">
      </el-table-column>

      <el-table-column prop="name" label="企业名称" width="300">
        <template slot-scope="scope">{{ scope.row.name || "-" }}</template>
      </el-table-column>

      <el-table-column prop="industry" label="行业分类" width="230">
        <template slot-scope="scope">{{ scope.row.industry || "-" }}</template>
      </el-table-column>

      <el-table-column prop="foundation_date" label="成立日期" width="110">
        <template slot-scope="scope">{{scope.row.foundation_date ?scope.row.foundation_date.split(' ')[0] : "-" }}</template>
      </el-table-column>

      <el-table-column
        prop="registryCapital"
        label="注册资本(万)"
        width="120"
      >
        <template slot-scope="scope">{{ scope.row.registryCapital || "-" }}</template>
      </el-table-column>

      <el-table-column prop="district" label="所属地区" width="240">
        <template slot-scope="scope">{{ scope.row.district || "-" }}</template>
      </el-table-column>

      <el-table-column prop="isPublished" label="在线状态" width="180">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.isPublished"
            @change="firmDataChange(scope.row)"
            active-text="上线"
            inactive-text="下线">
          </el-switch>
        </template>
        <!-- <template slot-scope="scope">{{ scope.row.isPublished === '0' ? '下线' : '上线' || "-" }}</template> -->
      </el-table-column>

      <el-table-column prop="publishTime" label="最近更新时间" width="200">
        <template slot-scope="scope">{{ scope.row.publishTime || "-" }}</template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="checkHandleClick(scope.row)" type="text" size="small">查看</el-button>
          <el-button @click="changeHandleClick(scope.row)" type="text" size="small">修改</el-button>
          <el-button type="text" size="small"  @click="open(scope.$index, scope.row)">删除</el-button>
          <el-button @click="preview(scope.row)" type="text" size="small">预览</el-button>
          <!-- <el-button v-if="scope.row.isPublished === '0' "
            type="text"
            size="small"
            @click="publish(scope.row)">发布
          </el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        title="企业详情预览"
        :visible.sync="centerDialogVisible"
        width="90%"
        center>
          <firm-detail></firm-detail>
          <!-- <firm-detail-preview></firm-detail-preview> -->
    </el-dialog>

    <paging :totalPage="totalPage"
      :pageSize="size"
      :CurrentPage="page"
      @curentPage="handleCurrentChange">
    </paging>

  </div>
</template>

<script>
import Paging from '@/components/paging.vue'
import FirmDetail from '../../firm/firmDetail.vue'
import { regionDataPlus, CodeToText } from 'element-china-area-data' // 省市区带‘全部’三级联动选择
// import FirmDetailPreview from '../../firm/firmDetailPreview.vue'
export default {
  name: 'compantInfo',
  props: {},
  components: {
    Paging,
    FirmDetail
    // FirmDetailPreview
  },
  data () {
    return {
      options: regionDataPlus, // 省市区带‘全部’三级联动选择
      selectedOptions: [],
      centerDialogVisible: false,
      countryCity: [{ id: -1, name: '全国', pid: 0 }], // 全国34个省市
      classifyList: [], // 所有行业分类
      status: [
        { status: '全部', code: -1 },
        { status: '上线状态', code: 1 },
        { status: '下线状态', code: 0 }
      ], // 发布状态
      totalPage: 0, // 总页数
      page: 1, // 默认页码
      size: 10, // 每页数据条数
      form: {
        name: null,
        classify: null,
        area: null,
        status: null
      },
      tableData: []
    }
  },
  computed: {},
  created () {
    this.getClassify()
    // this.getFirstCity()
    this.getFirmList()
    // console.log(this.$parent.sureitem)
    // // setTimeout(() => { this.$parent.sureitem = '/compantInfo' }, 1000)
    // this.$parent.sureitem = '/compantInfo'
    // console.log(this.$parent.sureitem)
  },

  mounted () {
    // this.$parent.sureitem = '/compantInfo'
    // if (location.href.indexOf('#reloaded') === -1) {
    //   location.href = location.href + '#reloaded'
    //   location.reload()
    // }
  },
  methods: {
    firmDataChange (row) {
      console.log(row,'打印信息---')
      console.log(row.isPublished)
      console.log(this.status)
      // return false;
      if (!row.publishTime) {
        // if( == true){

        // }
        this.$confirm(`${row.isPublished?'该记录从未发布过，是否发布上线！':'确定要下线吗？'}  `, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消', 
          type: 'warning'
        }).then(() => {
          this.$post(this.$url.companyInfoManage.publishUpdate, {
            basicId: row.id,
            isPublished: row.isPublished ? '1' : '0'
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message.success('修改成功！')
              this.getFirmList()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消发布'
          })
          this.getFirmList()
          // const Index = this.tableData.findIndex((item) => item.id === row.id)
          // row.isPublished = '0'
          // this.$set(this.tableData, Index, row)
        })
      } else {
        const res = this.$post(this.$url.companyInfoManage.publishUpdate, {
          basicId: row.id,
          // isPublished: this.status ? 1 : 0
          isPublished: row.isPublished ? '1' : '0'
        })
        const { code, msg } = res.data
        if (code === 200) {
          this.$message.success('修改成功！')
        } else {
          this.$message.error(msg)
        }
      }
    },

    // // 获取全国34个省市
    // async getFirstCity () {
    //   try {
    //     const res = await this.$get(this.$url.base.commonCity)
    //     const { code, msg, data } = res.data

    //     if (code === 200 && data) {
    //       this.countryCity = this.countryCity.concat(data)
    //     } else {
    //       this.$message.error(msg)
    //     }
    //   } catch (err) {
    //     console.log(err)
    //   }
    // },

    // 全国省市区三级联动
    handleChange () {
      var loc = ''
      for (let i = 0; i < this.selectedOptions.length; i++) {
        loc += CodeToText[this.selectedOptions[i]] + '-'
      }

      const locArray = loc.split('-')

      const newLocArray = locArray.filter((item) => {
        return item !== '全部' && item !== '市辖区' && item !== ''
      })

      this.form.area = newLocArray.join('-')
    },

    // 获取行业分类数据
    async getClassify () {
      try {
        const res = await this.$get(this.$url.activity.firmClassify)
        const { code, msg, data } = res.data
        if (code === 200 && data) {
          this.classifyList = data
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 获取企业列表
    async getFirmList () {
      if (this.form.registerCapital === '') { this.form.registerCapital = null }
      try {
        const res = await this.$post(this.$url.garden.GardenFirmList, {
          district: this.form.area, // 所属地区
          realm: this.form.classify, // 产业分类
          name: this.form.name, // 企业名称
          isPublished: this.form.status === -1 ? null : this.form.status, // 发布状态
          page: this.page,
          size: this.size
        })

        const { code, msg, data } = res.data
        if (code === 200) {
          this.totalPage = data.total
          this.tableData = data.data
          this.tableData.map((item) => {
            item.isPublished = item.isPublished === '0' ? 'false' : true
          })
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 重置
    reset () {
      this.selectedOptions = []
      this.form.area = null
      this.form.classify = null
      this.form.name = null
      this.form.status = null
      this.getFirmList()
    },

    // 分页功能
    handleCurrentChange (page) {
      this.page = page
      this.getFirmList()
    },

    // 获取企业详情
    async getFirmDetail (id) {
      try {
        const res = await this.$get(this.$url.firm.firmDetail + id)

        const { code, msg, data } = res.data
        if (code === 200) {
          // console.log(data.info.companyPicture.split(','))
          // console.log(data.info.gloryPicture.split(','))
          // data.info.companyPicture = data.info.companyPicture ? data.info.companyPicture.split(',') : []
          // data.info.gloryPicture = data.info.gloryPicture ? data.info.gloryPicture.split(',') : []

          const info = Object.assign(data.info, data.basic, { appraiseTime: data.appraiseTime })
          // console.log(data)
          console.log(info)

          sessionStorage.setItem('firmInfoCheck', JSON.stringify(info))
          // console.log(data)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 查看
    checkHandleClick (row) {
      console.log('查看行数据')
      console.log(row)
      this.getFirmDetail(row.id)

      setTimeout(() => {
        this.$router.push({
          path: '/firmSituation',
          query: {
            id: row.id,
            status: 1,
            name: row.name,
            type: 1,
            Ptime: row.publishTime
          }
        })
      }, 2000)
    },

    // 修改
    changeHandleClick (row) {
      // console.log('修改行数据')
      // console.log(row)
      this.getFirmDetail(row.id)

      setTimeout(() => {
        this.$router.push({
          path: '/firmSituation',
          query: {
            id: row.id,
            status: 2,
            name: row.name,
            Ptime: row.publishTime,
            Published: row.isPublished
          }
        })
      }, 2000)
    },

    // 预览
    preview (row) {
      this.$route.query.id = row.id
      this.centerDialogVisible = true
      // this.$route.query.id = null
    },

    // 发布
    async publish (row) {
      // const data = new Date()
      // const M = (data.getMonth() + 1) >= 10 ? data.getMonth() + 1 : '0' + (data.getMonth() + 1)
      // const d = data.getDate() >= 10 ? data.getDate() : '0' + data.getDate()
      // const t = data.toLocaleTimeString().split('午').slice(-1).join()
      // const nowDate = (data.getUTCFullYear()) + '-' + M + '-' + d + ' ' + t // 当前日期
      // console.log(nowDate)
      try {
        const res = await this.$post(this.$url.companyInfoManage.firmDataChange, {
          basicId: row.id,
          isPublished: '1' // 是否发布
          // PublishTime: nowDate
        })
        const { code, msg } = res.data
        if (code === 200) {
          this.$message.success('发布成功！')
          this.getFirmList()
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },

    // 删除
    async handleDelete (index, row) {
      console.log(index, row)
      try {
        const res = await this.$post(this.$url.companyInfoManage.firmDataChange, {
          basicId: row.id,
          isDelete: 1
        })
        const { code, msg, data } = res.data
        if (code === 200) {
          // sessionStorage.setItem('firmInfoCheck', JSON.stringify(data))
          this.tableData.splice(index, 1)
          console.log(data)
        } else {
          this.$message.error(msg)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 删除前提示
    open (index, row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleDelete(index, row)
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    goSomePage (path) {
      sessionStorage.removeItem('firmInfoCheck')

      setTimeout(() => {
        this.$router.push(path)
      }, 2000)

      // this.$router.push(path)
    }
  }
}
</script>

<style scoped lang="less">
.compantInfo {
  padding: 0 20px;
}
.search-item {
  position: relative;
  margin: 30px 0;
  padding: 0 150px 0 0;
  /deep/.el-form-item__label{
    padding: 0;
    text-align: left;
  }
  .btn-style{
    position: absolute;
    right: 0;
    top: 0;
  }
  .form-item {
    display: flex;
    justify-content: left;
    .items {
      margin-right: 20px;
    }
  }
}
/deep/.el-dialog__header {
  box-sizing: border-box;
  padding: 46px 0 0;
}
/deep/.is-leaf {
  background-color: #3056d9;
  font-size: 14px;
  color: #fff !important;
  text-align: center !important;
}
/deep/.el-table__row:nth-of-type(2n-1) {
  background-color: #fafafa;
}
/deep/.cell {
  text-align: center !important;
}
/deep/.el-button--default {
  width: 119px;
  height: 34px;
}
</style>
